import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699eeee8f782d50014882d33/baninvest/src/app/homepage/components/HomepageInteractive.tsx");
